import { card, property_image } from './styles.module.scss';

const SkeletonCard = () => {
  return (
    <div className={card}>
      <div className={property_image}></div>
    </div>
  );
};

export default SkeletonCard;
